// extracted by mini-css-extract-plugin
export default {"map":"MapSection_map__dngXI","mapLabel":"MapSection_mapLabel__bi4Po","clickLayer":"MapSection_clickLayer__MGN+W"};